import React, { useContext, useEffect } from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import ProgressBar from '../ProgressBar/ProgressBar';
import layout from '../../stylesheets/layout.module.scss';
import style from './Loading.module.scss';
import { ThemeContext } from '../App/App';
import messages from '../../messages/feMessages';

interface LoadingProps {
	progress: number;
	handlePageChange: () => void;
}

export default ({ progress, handlePageChange }: LoadingProps) => {
	const { formatMessage } = useIntl();
	const { styles: themeStyle, images } = useContext(ThemeContext);

	useEffect(() => {
		handlePageChange();
	}, [handlePageChange]);

	return (
		<>
			<ProgressBar progress={progress} />
			<div className={layout.container}>
				<div className={style.imageContainer}>
					{images.loadingBackImage && (
						<images.loadingBackImage className={themeStyle.loadingIdBack} />
					)}
					{images.loadingIndicator && (
						<images.loadingIndicator
							className={classNames(themeStyle.loadingIndicator, style.indicator)}
						/>
					)}
				</div>
				<h1 className={classNames(themeStyle.title, style.title)}>
					{formatMessage(messages.loadingTitle)}
				</h1>
				<div className={style.text}>{formatMessage(messages.loadingText)}</div>
			</div>
		</>
	);
};
